// 代祭扫商品列表

import request from "@/utils/request";

//保存预约信息 返回预约码
export function replaceSacrifice_commodities(data) {
  return request({
    url: "/sys/replaceSacrifice/commodities",
    method: "post",
    data,
  });
}
